module.exports = __webpack_public_path__ + "media/illustrations/start-search-b98e3f96.svg";